import React, { FC, useCallback, useState } from "react";
import { Layout } from "pyxis-ui-kit";
import backNavigationIcon from "../../../../assets/svg/BackArrowAgencyFiles.svg";
import "./index.scss"; // Renamed for clarity
import { useParams } from "react-router-dom";
import { browseTemplatesUrls } from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import { RaiseAdRequestState } from "../../../../store/types/raiseAdRequest";
import {
  deleteNoticeRequestAction,
  raiseNewRequestAction,
} from "../../../../store/actions/raiseAdRequest";
import DeleteResourceModal from "../../../AgencyFileDrop/components/DeleteResourceModal";
import canelIcon from "../../../../assets/svg/circledCancelIcon.svg";

export const NoticeAdHeader: FC = () => {
  const dispatch = useDispatch();
  const {
    allRequests,
    userRole,
    lastStepName,
    quoationApprovalFormData,
  } = useSelector(
    (state: { raiseAdRequest: RaiseAdRequestState }) => state.raiseAdRequest
  );
  const { stepKey, requestId, selectedProductId } = useParams<{
    stepKey: string;
    requestId: string;
    selectedProductId: string;
  }>();
  const handleBackClick = useCallback(() => {
    if (!!requestId) {
      const urlFormed = `#/cocreate/raise-notice-ad/${selectedProductId}`;
      window.location.assign(urlFormed);
    } else {
      const urlFormed = `#/`;
      window.location.assign(urlFormed);
    }
  }, [requestId, selectedProductId]);

  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(
    false
  );

  const handleRaiseNewRequest = useCallback(() => {
    dispatch(raiseNewRequestAction(selectedProductId));
  }, [dispatch, selectedProductId]);

  const handleBrowseTemplates = useCallback(() => {
    window.open(browseTemplatesUrls[selectedProductId], "_blank");
  }, [selectedProductId]);

  const handleDeleteModalVisible = useCallback(() => {
    setIsDeleteModalVisible(true);
  }, []);

  const handleDeleteRequest = useCallback(() => {
    dispatch(deleteNoticeRequestAction({ selectedProductId, requestId }));
    setIsDeleteModalVisible(false);
  }, [dispatch, requestId, selectedProductId]);

  return (
    <>
      <Layout>
        <div className="notice-ad-header">
          {/* Left Section: Back button + Title */}
          <div className="notice-ad-header__left">
            <img
              src={backNavigationIcon}
              alt="Back"
              className="notice-ad-header__back-icon"
              onClick={handleBackClick}
            />
            <div className="notice-ad-header__title">
              Raise Notice Ad Request
            </div>
          </div>

          {/* Right Section: Action buttons */}
          <div className="notice-ad-header__actions">
            {(userRole === "admin" || userRole === "product-admin") &&
            !quoationApprovalFormData.trashed_at ? (
              !!requestId ? (
                <button
                  className="btn btn--red"
                  onClick={handleDeleteModalVisible}
                >
                  Cancel Request
                </button>
              ) : (
                <></>
              )
            ) : (
              <></>
            )}
            {!!allRequests.count && !requestId ? (
              <>
                <button
                  className="btn btn--outline-purple"
                  onClick={handleBrowseTemplates}
                >
                  Browse Templates
                </button>
                <button
                  className="btn btn--purple"
                  onClick={handleRaiseNewRequest}
                >
                  Raise a new Request
                </button>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      </Layout>

      <DeleteResourceModal
        isModalOpen={isDeleteModalVisible}
        setModalOpen={setIsDeleteModalVisible}
        modalTitle="Cancel Request?"
        modalDesc="Are you sure you want to cancel this request, all the information under this request will be permanently removed."
        handleDeleteClick={handleDeleteRequest}
        img={canelIcon}
      />
    </>
  );
};
